import React, { ReactNode } from 'react';
import { Form as FormikForm, Formik, FormikProps, FormikValues } from 'formik';
import * as Yup from 'yup';

interface IProps<T> {
  initialValues: T;
  onSubmit: (value: T) => void | Promise<void>;
  validationSchema?: ReturnType<typeof Yup.object>;
  children: ((props: FormikProps<T>) => ReactNode) | ReactNode | ReactNode[];
}

function Form<T extends FormikValues>({ initialValues, onSubmit, validationSchema, children }: IProps<T>) {
  const renderChildren = (props: FormikProps<T>): ReactNode | ReactNode[] => {
    return typeof children === 'function' ? children(props) : children;
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {(props: FormikProps<T>) => <FormikForm className="modForm">{renderChildren(props)}</FormikForm>}
    </Formik>
  );
}

export default Form;
